import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  BaseBackResponse,
  INTERVENTION_REPORT_STATE,
  ReverseMoney,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../../../helpers';
import { apiCall } from '../../../../services';

const ENDPOINT = `${APIConfiguration.repairer}files/${COMMON_QUERY_PARAMS.FILE_ID}/interventionreport`;

interface AdministrativeFeesReportLine {
  id?: string;
  type: 'administrativeFee';
  description: string;
  administrativeFee: {
    priceIncludedTax: ReverseMoney;
  };
}

interface DiscountReportLine {
  id?: string;
  type: 'discount';
  description: string;
  discount: {
    priceIncludedTax: ReverseMoney;
  };
}

interface ServiceReportLine {
  id?: string;
  type: 'service';
  service: {
    serviceId: string;
  };
}

interface UnknownServiceReportLine {
  id?: string;
  type: 'unknownService';
  unknownService: {
    priceIncludedTax: ReverseMoney;
  };
}

interface StockItemReportLine {
  id?: string;
  type: 'sparePart';
  description: string;
  sparePart: {
    stockItemId: string;
  };
}

interface UnknownSparePartReportLine {
  id?: string;
  type: 'unknownSparePart';
  description: string;
  unknownSparePart: {
    supplierId?: string;
    reference: string;
    preTaxBuyingPrice: ReverseMoney;
    preTaxSellingPrice: ReverseMoney;
  };
}

export type SetInterventionReportLine =
  | AdministrativeFeesReportLine
  | DiscountReportLine
  | ServiceReportLine
  | UnknownServiceReportLine
  | StockItemReportLine
  | UnknownSparePartReportLine;

interface SetInterventionReportArgs {
  fileId: string;
  reportLines: SetInterventionReportLine[];
  state: INTERVENTION_REPORT_STATE.DRAFT | INTERVENTION_REPORT_STATE.VALIDATED;
  comment: string;
}

export async function setInterventionReport(
  payload: SetInterventionReportArgs,
): Promise<BaseBackResponse> {
  try {
    const response = await apiCall(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, payload.fileId),
      {
        method: SUPPORTED_METHODS.PUT,
        json: {
          comment: payload.comment,
          state: payload.state,
          reportLines: payload.reportLines,
        },
      },
    );

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}
